import React, { useMemo, useRef } from 'react';
import { Alert, Modal, Button, Spinner } from 'react-bootstrap';
import { sanitizarAviso } from '../Shared/Utils/avisos';
import './Configuracoes.css';

export default function ModalAviso({ aviso, onClose, onDismiss, dismissing = false, dismissError = '', preview = false, restantes = 0 }) {
  const ultimoAviso = useRef(null);
  if (aviso) ultimoAviso.current = aviso;
  const conteudo = aviso || ultimoAviso.current;
  const html = useMemo(() => sanitizarAviso(conteudo?.conteudoHtml), [conteudo?.conteudoHtml]);
  return <Modal show={Boolean(aviso)} onHide={() => { if (!dismissing) onClose(); }} backdrop={dismissing ? 'static' : true}
    keyboard={!dismissing} size="lg" centered scrollable aria-labelledby="titulo-modal-aviso">
    <Modal.Header closeButton={!dismissing} closeLabel="Fechar aviso">
      <Modal.Title id="titulo-modal-aviso" className="text-danger">{preview ? 'Pré-visualização: ' : ''}{conteudo?.titulo || 'Aviso aos clientes'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {dismissError && <Alert variant="danger" role="alert">{dismissError}</Alert>}
      <div className="aviso-conteudo" dangerouslySetInnerHTML={{ __html: html }} />
    </Modal.Body>
    <Modal.Footer>
      {restantes > 0 && <span className="text-muted me-auto">Mais {restantes} {restantes === 1 ? 'aviso' : 'avisos'}</span>}
      {!preview && onDismiss && <Button variant="outline-danger" disabled={dismissing} onClick={onDismiss}>
        {dismissing && <Spinner animation="border" size="sm" className="me-2" />}
        Não exibir novamente
      </Button>}
      <Button variant="secondary" disabled={dismissing} onClick={onClose}>{preview ? 'Fechar pré-visualização' : restantes > 0 ? 'Próximo aviso' : 'Entendi'}</Button>
    </Modal.Footer>
  </Modal>;
}
